import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {PermissionModule} from '../../../../shared/permission';
import {PaymentSuccessModalComponent} from './payment-success-modal.component';

@NgModule({
  declarations: [
    PaymentSuccessModalComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTabsModule,
    MatSelectModule,
    PermissionModule
  ],
  exports: [
    PaymentSuccessModalComponent
  ]
})

export class PaymentSuccessModalModule {
}
